import { Input, Form } from 'antd';
import React from 'react';
import { StyledButtonBlueUnbordered, StyledButtonLogin, StyledButtonWrapper } from 'components/styledComponents/button/Button.styled';
import { FormInputWrapper } from 'components/styledComponents/input/Input.styled';
import {
  StyledFlexEndResend, StyledForgetLink, StyledFormItems, StyledTitleForm,
} from 'app/auth/components/Login.styled';
import { FormItemMarginTopWrapper } from 'shared/Common.styled';
import { useAppDispatch } from 'store/hooks';
import { FormItemErrorMessage } from 'shared/formControl';
import { HandleSubmitType } from './Login';

interface LoginStep2Props {
    handleSubmit: HandleSubmitType;
    changeTFAState: (state: boolean) => void;
}

const LoginStep2 = ({ handleSubmit, changeTFAState }: LoginStep2Props) => {
  const dispatch = useAppDispatch();

  return (
    <>
      <StyledTitleForm>Enter Code</StyledTitleForm>
      <StyledFormItems>
        <FormInputWrapper>
          <Form.Item
            label="Authentication Code"
            name="tfa_code"
            rules={[
              {
                required: true,
                message: <FormItemErrorMessage errorMassage="TFA code cannot be empty!" />,
              },
            ]}
          >
            <Input placeholder="TFA code" allowClear autoFocus />
          </Form.Item>
        </FormInputWrapper>
      </StyledFormItems>
      <StyledFlexEndResend>
        <StyledForgetLink to="/resendTFA">Recover 2FA?</StyledForgetLink>
      </StyledFlexEndResend>
      <FormItemMarginTopWrapper>
        <StyledButtonWrapper>
          <StyledButtonBlueUnbordered type="primary" onClick={() => dispatch(changeTFAState(false))}>
            Back
          </StyledButtonBlueUnbordered>
          <StyledButtonLogin type="primary" htmlType="submit" onClick={handleSubmit}>
            Send
          </StyledButtonLogin>
        </StyledButtonWrapper>
      </FormItemMarginTopWrapper>
    </>
  );
};

export default LoginStep2;
